import * as betgalaxy from './Forms.styles.betgalaxy';
import * as betprofessor from './Forms.styles.betprofessor';
import * as betroyale from './Forms.styles.betroyale';
import * as puntcity from './Forms.styles.puntcity';
import * as puntgenie from './Forms.styles.puntgenie';
import * as questbet from './Forms.styles.questbet';
import * as sterlingparker from './Forms.styles.sterlingparker';
import * as vikingbet from './Forms.styles.vikingbet';
import * as volcanobet from './Forms.styles.volcanobet';
import * as wellbet from './Forms.styles.wellbet';
import * as juicybet from './Forms.styles.juicybet';
import * as goldenrush from './Forms.styles.goldenrush';
import * as forsport from './Forms.styles.forsport';
import * as fiestabet from './Forms.styles.fiestabet';
import * as junglebet from './Forms.styles.junglebet';
import * as oldgill from './Forms.styles.oldgill';
import * as sugarcastle from './Forms.styles.sugarcastle';
import * as buffalobet from './Forms.styles.buffalobet';
import * as titanbet from './Forms.styles.titanbet';
import * as templebet from './Forms.styles.templebet';
import * as slambet from './Forms.styles.slambet';
import * as gigabet from './Forms.styles.gigabet';
import * as betstride from './Forms.styles.betstride';
import * as goldenbet888 from './Forms.styles.goldenbet888';
import * as hyperbet from './Forms.styles.hyperbet';
import * as bet777 from './Forms.styles.bet777';
import * as chromabet from './Forms.styles.chromabet';
import * as bet575 from './Forms.styles.bet575';
import * as epicodds from './Forms.styles.epicodds';
import * as pyramidbet from './Forms.styles.pyramidbet';
import * as magnumbet from './Forms.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  juicybet,
  goldenrush,
  forsport,
  fiestabet,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  templebet,
  slambet,
  gigabet,
  betstride,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
